import React from 'react';
import type {
  Countries,
  Languages,
} from '../../../../../i18n/i18n.language-config';
import {
  COUNTRY_MAPPING,
  languages,
} from '../../../../../i18n/i18n.language-config';

export const LocaleContext = React.createContext({
  language: languages['en-US'] as Languages,
});

export const LocaleProvider = (props: LocaleProviderProps) => {
  let _language = props.language;
  if (props.country) {
    _language = COUNTRY_MAPPING[props.country];
  }

  if (!_language) {
    throw new Error('Invalid language');
  }

  return (
    <LocaleContext.Provider value={{ language: _language }}>
      {props.children}
    </LocaleContext.Provider>
  );
};

export type LocaleProviderProps = {
  children: React.ReactNode;
} & (
  | { country: Countries; language?: never }
  | { language: Languages; country?: never }
);

export const useLocale = () => {
  const context = React.useContext(LocaleContext);

  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }

  return context;
};
